// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDHRPCSSheKRQdyu0UpLhYh08C3qScwvLw",
  authDomain: "oraku-smart-ai-v2.firebaseapp.com",
  projectId: "oraku-smart-ai-v2",
  storageBucket: "oraku-smart-ai-v2.firebasestorage.app",
  messagingSenderId: "355527024544",
  appId: "1:355527024544:web:67a16ca801a62574b14ec5",
  measurementId: "G-YVH0D98YZD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// 🔒 Firebase App Check (reCAPTCHA Enterprise)
// Protects callable functions, Firestore, and Storage from non-browser /
// non-admin traffic. The site key below is the *public* reCAPTCHA Enterprise
// key from Google Cloud Console → Security → reCAPTCHA Enterprise. It is
// safe to ship in client code; the matching secret never leaves Google.
//
// To create one (one-time):
//   1. Go to https://console.cloud.google.com/security/recaptcha
//   2. Pick the oraku-smart-ai-v2 project
//   3. "Create key" → platform: Website → domains: localhost +
//      <your prod admin domain>. Type: score-based (no challenge).
//   4. Copy the resulting site key into RECAPTCHA_ENTERPRISE_SITE_KEY below.
//   5. In Firebase Console → App Check → Web app → reCAPTCHA Enterprise,
//      paste the SAME key so Firebase trusts it.
//
// Until the real key is pasted in, App Check will fail-open in dev (the
// SDK logs a warning) and any backend with `enforceAppCheck: true` will
// reject this admin's requests — that's the intended hard fail.
const RECAPTCHA_ENTERPRISE_SITE_KEY = "6LdDWdssAAAAABcJ2DHQzZLhcm_QoIbd9K-qK52Z";

// ── Localhost bypass ──
// On localhost, skip App Check init entirely. The Oraku backend functions
// (`orakuChat`, `orakuTTS`, `getDeepgramToken`) DO enforce App Check in
// production, so localhost dev work needs a way to skip it without
// fiddling with debug-token registration on every machine. Production
// is unaffected — App Check kicks in there.
const IS_LOCALHOST =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

if (!IS_LOCALHOST) {
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(RECAPTCHA_ENTERPRISE_SITE_KEY),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (e) {
    // Don't crash the admin if App Check init fails (e.g., key not set yet);
    // backend enforcement will surface it as a clear permission error.
    // eslint-disable-next-line no-console
    console.warn("⚠️ Firebase App Check init failed:", e);
  }
} else {
  // eslint-disable-next-line no-console
  console.info("ℹ️ Skipping Firebase App Check init on localhost (dev mode).");
}

// Export the services your app needs
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const googleProvider = new GoogleAuthProvider();
export default app;